/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'date_format': 'DD.MM.YYYY',
    'date_format_short': 'DD.MM',
    'date_time_format': 'MMMM D, YYYY HH:mm',
    'day_names': ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    'month_names': ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
  },

  /* english */
  en: {
    'date_format': 'MM/DD/YYYY',
    'date_format_short': 'MM/DD',
    'date_time_format': 'MMMM D, YYYY hh:mm A',
    'day_names': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    'month_names': ['January', 'February', 'March', 'April', 'Mai', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  }
}
